import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { ref, get } from 'firebase/database';
import { auth, database } from '../firebase';
import { useNavigate } from 'react-router-dom';

export default function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    // Email autorizado para acesso ao painel admin
    const AUTHORIZED_EMAIL = 'danielinvestigador@gmail.com';

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        // Verificar se o email é o autorizado
        if (email.toLowerCase() !== AUTHORIZED_EMAIL.toLowerCase()) {
            setError('⛔ Acesso negado! Este painel é restrito ao administrador.');
            setLoading(false);
            return;
        }

        try {
            const userCredential = await signInWithEmailAndPassword(auth, email, password);

            // Verificar novamente após login (dupla verificação)
            if (userCredential.user.email.toLowerCase() !== AUTHORIZED_EMAIL.toLowerCase()) {
                await auth.signOut();
                setError('⛔ Acesso negado! Este painel é restrito ao administrador.');
                setLoading(false);
                return;
            }

            // Verificar se o usuário está bloqueado
            const userId = userCredential.user.uid;
            const userEmail = userCredential.user.email;
            
            // Tentar buscar por UID primeiro
            let userRef = ref(database, `users/${userId}`);
            let userSnapshot = await get(userRef);
            let userData = null;
            
            // Se não encontrar por UID, buscar por email
            if (!userSnapshot.exists()) {
                const usersRef = ref(database, 'users');
                const allUsersSnapshot = await get(usersRef);
                if (allUsersSnapshot.exists()) {
                    const allUsers = allUsersSnapshot.val();
                    // Procurar usuário por email
                    for (const [key, user] of Object.entries(allUsers)) {
                        if (user && user.email && user.email.toLowerCase() === userEmail.toLowerCase()) {
                            userData = user;
                            console.log('Usuário encontrado por email:', key, userData);
                            break;
                        }
                    }
                }
            } else {
                userData = userSnapshot.val();
                console.log('Usuário encontrado por UID:', userId, userData);
            }
            
            // Verificar se está bloqueado (verifica boolean true, string "true", ou 1)
            const isBlocked = userData && (userData.blocked === true || userData.blocked === 'true' || userData.blocked === 1);
            console.log('Status de bloqueio verificado:', { 
                userData: userData ? { blocked: userData.blocked, email: userData.email } : null, 
                isBlocked 
            });
            
            if (isBlocked) {
                await auth.signOut();
                setError('🚫 Sua conta foi bloqueada. Entre em contato com o administrador.');
                setLoading(false);
                return;
            }

            // Acesso permitido
            navigate('/');
        } catch (err) {
            if (err.code === 'auth/user-not-found') {
                setError('❌ Usuário não encontrado.');
            } else if (err.code === 'auth/wrong-password') {
                setError('❌ Senha incorreta.');
            } else if (err.code === 'auth/invalid-email') {
                setError('❌ Email inválido.');
            } else {
                setError('❌ Falha no login. Verifique suas credenciais.');
            }
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-container">
            <div className="auth-card">
                <h1 className="auth-title">Admin Portal</h1>
                {error && <div style={{ color: 'var(--danger)', marginBottom: '1rem', textAlign: 'center' }}>{error}</div>}
                <form onSubmit={handleLogin}>
                    <input
                        type="email"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                    <input
                        type="password"
                        placeholder="Senha"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                    <button
                        type="submit"
                        className="btn btn-primary"
                        style={{ width: '100%', marginTop: '1rem' }}
                        disabled={loading}
                    >
                        {loading ? '⏳ Verificando acesso...' : 'Entrar'}
                    </button>
                </form>
            </div>
        </div>
    );
}
